import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { createTheme, ThemeProvider }, "@mui/material/Accordion": Accordion, "@mui/material/AccordionSummary": AccordionSummary, "@mui/material/AccordionDetails": AccordionDetails, "@mui/material/Typography": Typography, "@mui/icons-material/ExpandMore": ExpandMoreIcon, "@mui/material/Box": Box, "@mui/material/Switch": Switch } } });
export default ClientProvider;
